import { render, staticRenderFns } from "./sliding.vue?vue&type=template&id=921de072&scoped=true&"
import script from "./sliding.vue?vue&type=script&lang=js&"
export * from "./sliding.vue?vue&type=script&lang=js&"
import style0 from "./sliding.vue?vue&type=style&index=0&id=921de072&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921de072",
  null
  
)

export default component.exports